/* 

// Code to refactor without jQuery


let FNTimer = null;

function chronAJ() {
	const chronNext = document.querySelectorAll(".chron-next-link");
	if (chronNext.length > 0) {
		// inView(".chron-next-link").on("enter", function (elIV) {
		// loop through chronNext
		chronNext.forEach((chronNextSingle) => {
			if (chronNextSingle.classList.contains("processed")) {
				//console.log("already processed this one. Moving on");
			} else {
				let chronTarget = chronNextSingle.getAttribute("href");
				// set class on chronNextSingle parent element
				chronNextSingle.classList.add("processed");
				let targetHREF = chronTarget;
				if (ajLoadCheck.indexOf(targetHREF) === -1) {
					ajLoadCheck.push(targetHREF);
					if (targetHREF !== "") {
						$.get(targetHREF, function (data) {
							// console.log(data);
							let targetHTML = $(data)
								.find(".chron-aj-wrap")
								.html();
							targetHTML = targetHTML.replace(
								"chron-next-link processed",
								"chron-next-link"
							);
							$(".chron-aj-wrap").append(targetHTML);
							setTimeout(function () {
								chronCB();
							}, 100);
						});
					}
				}
			}
		});
		// });
	}
}

let scrollBasedState = null;
function chronScrollCheck() {
	$(".chron-aj-wrap").scroll(function () {
		// when scrolling the .chron-aj-wrap div, check if the scroll is within 2 screen heights of the bottom
		let scrollPos = $(this).scrollTop();
		let scrollMax = $(this)[0].scrollHeight - $(this).height();
		let scrollDiff = scrollMax - scrollPos;
		let scrollCheck = $(window).height() * 2;

		if (scrollDiff < scrollCheck) {
			chronAJ();
		}

		let doingAutoScroll = false;
		$(".scrollTriggers").each(function () {
			// let targetOffset = $(this).offset().top;
			// console.log("checking scrolltriggers");
			if (inView.is($(this)[0])) {
				// console.log("scrollTriggers inView");
				if ($(this).data("page") !== scrollBasedState) {
					scrollBasedState = $(this).data("page");
					// console.log($(this).data("bg"), $(this).data("page"));
					$(".chron-aj-wrap").css({ "--bg": $(this).data("bg") });
					// set the url to $(this).data("page")
					window.history.pushState(
						{ page: $(this).data("page") },
						$(this).data("page"),
						$(this).data("page")
					);

					if (
						$(
							".chron-landing a[data-bg='" +
								$(this).data("bg") +
								"']"
						).hasClass("set-chron-bg-color") &&
						!doingAutoScroll
					) {
						let newOffset =
							$(
								".chron-landing a[data-bg='" +
									$(this).data("bg") +
									"']"
							)
								.first()
								.offset().top - 100;
						newOffset = parseInt(newOffset);
						// console.log(newOffset);
						if (newOffset && newOffset > 100) {
							doingAutoScroll = true;
							document.querySelector("html,body").scrollTop =
								newOffset;
							// $("HTML, BODY").animate(
							// 	{ scrollTop: newOffset },
							// 	300
							// );
							// setTimeout(() => {
							// 	document.querySelector("html,body").scrollTop =
							// 		newOffset;
							// }, 1000);
						} else {
						}
					}
				}
			}
		});
	});

	// test if any .chron-top elements are inView
	inView(".chron-top").on("enter", function (elIV) {
		console.log("chron top inView");
	});
	
}
chronScrollCheck();

*/
// import { inView } from "in-view";
const inView = require('in-view');

export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		this.allowFetch = true;
		this.scrollBasedState = null;
		this.ajLoadCheck = [];
		Object.assign(this.options, this.defaults, options);

		this.namespace = "jfChronology";
		if (this.options.$el) {
			this.$el = this.options.$el;
		}
		this.init(true);
	}

	init(bool) {
		if (bool) {
			this.chronCB();
			this.chronScrollCheck();

			document.querySelectorAll(".chron-aj-close").forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();
					document
						.querySelector("html,body")
						.classList.remove("chron-panel-on");
					if (document.querySelector(".chron-next-link.processed")) {
						document
							.querySelector(".chron-next-link.processed")
							.classList.remove("processed");
					}

					this.ajLoadCheck = [];
					window.history.pushState(
						{ page: "/chronology/" },
						"/chronology/",
						"/chronology/"
					);
				});
			});
		} else {
		}
	}

	chronCB() {
		document.querySelectorAll(".set-chron-bg-color").forEach((el) => {
			el.addEventListener("click", () => {
				let newBG = el.getAttribute("data-bg");
				if (newBG) {
					document
						.querySelector(".chron-aj-wrap")
						.style.setProperty("--bg", newBG);
				}
			});
		});

		document.querySelectorAll(".chron-landing a").forEach((el) => {
			if (!el.classList.contains("chron-landing-init")) {
				el.classList.add("chron-landing-init");
				el.addEventListener("click", (e) => {
					e.preventDefault();
					document.querySelector(".chron-aj-wrap").innerHTML = "";
					let targetHREF = el.getAttribute("href");
					if (targetHREF !== "") {
						let newOffset = el.offsetTop - 100;
						newOffset = parseInt(newOffset);
						// console.log(newOffset);
						if (newOffset && newOffset > 100) {
							document.querySelector("html,body").scrollTop =
								newOffset;
						}

						fetch(targetHREF)
							.then((response) => response.text())
							.then((data) => {
								// console.log(data);

								// parse data as html
								const parser = new DOMParser();
								const ajDocument = parser.parseFromString(
									data,
									"text/html"
								);
								// console.log(ajDocument);
								if (
									ajDocument.querySelector(".chron-aj-wrap")
								) {
									let targetHTML =
										ajDocument.querySelector(
											".chron-aj-wrap"
										).innerHTML;
									document.querySelector(
										".chron-aj-wrap"
									).innerHTML = targetHTML;
									document
										.querySelector("html, body")
										.classList.add("chron-panel-on");
									setTimeout(() => {
										this.chronCB();
									}, 100);
								}
							});
					}
				});
			}
		});

		if (document.querySelector("button.footnote")) {
			document.querySelectorAll("button.footnote").forEach((el) => {
				if (!el.classList.contains("fn-init")) {
					el.classList.add("fn-init");

					el.addEventListener("mouseenter", () => {
						clearTimeout(this.FNTimer);
						document
							.querySelectorAll(".footnote-vis")
							.forEach((el) => {
								el.remove();
							});
						let targetRef = el.getAttribute("data-target-ref");
						let addClass = "";

						if (el.parentNode.classList.contains("dir-up")) {
							addClass = " dir-up";
						}
						if (el.parentNode.classList.contains("dir-mid")) {
							addClass = " dir-mid";
						}
						// console.log(targetRef);
						if (
							document
								.querySelector("#fn_" + targetRef)
								.classList.contains("footnote")
						) {
							let fnHTML = document.querySelector(
								"#fn_" + targetRef
							).innerHTML;
							// console.log(fnHTML);
							el.parentNode.insertAdjacentHTML(
								"beforeend",
								'<div class="footnote-vis' +
									addClass +
									'">' +
									fnHTML +
									"</div>"
							);
						}
					});

					el.addEventListener("mouseleave", () => {
						document
							.querySelectorAll(".footnote-vis")
							.forEach((el) => {
								el.classList.add("out");
							});
					});
				}
			});
		}
	}
	chronAJ() {
		const chronNext = document.querySelectorAll(".chron-next-link");
		if (chronNext.length > 0) {
			// inView(".chron-next-link").on("enter", function (elIV) {
			// loop through chronNext
			chronNext.forEach((chronNextSingle) => {
				if (chronNextSingle.classList.contains("processed")) {
					//console.log("already processed this one. Moving on");
				} else {
					let chronTarget = chronNextSingle.getAttribute("href");
					// set class on chronNextSingle parent element
					chronNextSingle.classList.add("processed");
					let targetHREF = chronTarget;
					if (this.ajLoadCheck.indexOf(targetHREF) === -1) {
						this.ajLoadCheck.push(targetHREF);
						if (targetHREF !== "") {
							fetch(targetHREF)
								.then((response) => response.text())
								.then((data) => {
									// console.log(data);

									// parse data as html
									const parser = new DOMParser();
									const ajDocument = parser.parseFromString(
										data,
										"text/html"
									);
									// console.log(ajDocument);
									if (
										ajDocument.querySelector(
											".chron-aj-wrap"
										)
									) {
										let targetHTML =
											ajDocument.querySelector(
												".chron-aj-wrap"
											).innerHTML;
										targetHTML = targetHTML.replace(
											"chron-next-link processed",
											"chron-next-link"
										);
										document.querySelector(
											".chron-aj-wrap"
										).innerHTML += targetHTML;
										setTimeout(() => {
											this.chronCB();
										}, 100);
									}
								});
						}
					}
				}
			});
			// });
		}
	}
	chronScrollCheck() {
		// when scrolling the .chron-aj-wrap div, check if the scroll is within 2 screen heights of the bottom
		const scrollParent = document.querySelector(".chron-aj-wrap");
		if (!scrollParent) {
			return;
		}

		scrollParent.classList.add("processed");
		scrollParent.addEventListener("scroll", () => {
			let scrollPos = scrollParent.scrollTop;
			let scrollMax =
				scrollParent.scrollHeight - scrollParent.clientHeight;
			let scrollDiff = scrollMax - scrollPos;
			let scrollCheck = window.innerHeight * 2;

			// console.table({
			// 	scrollPos,
			// 	scrollMax,
			// 	scrollDiff,
			// 	scrollCheck,
			// });

			if (scrollDiff < scrollCheck) {
				this.chronAJ();
			}
			let doingAutoScroll = false;

			if (
				document.querySelectorAll(".scrollTriggers") &&
				document.querySelectorAll(".scrollTriggers").length > 0
			) {
				document.querySelectorAll(".scrollTriggers").forEach((el) => {
					// console.log(el);
					// console.log(inView);
					if (inView.is(el)) {
						// console.log("scrollTriggers inView");
						if (el.dataset.page !== this.scrollBasedState) {
							this.scrollBasedState = el.dataset.page;
							// console.log(el.dataset.bg, el.dataset.page);
							document
								.querySelector(".chron-aj-wrap")
								.style.setProperty("--bg", el.dataset.bg);
							// set the url to $(this).data("page")
							window.history.pushState(
								{ page: el.dataset.page },
								el.dataset.page,
								el.dataset.page
							);

							if (
								document
									.querySelector(
										".chron-landing a[data-bg='" +
											el.dataset.bg +
											"']"
									)
									.classList.contains("set-chron-bg-color") &&
								!doingAutoScroll
							) {
								let newOffset =
									document.querySelector(
										".chron-landing a[data-bg='" +
											el.dataset.bg +
											"']"
									).offsetTop - 100;
								newOffset = parseInt(newOffset);
								// console.log(newOffset);
								if (newOffset && newOffset > 100) {
									doingAutoScroll = true;
									document.querySelector(
										"html,body"
									).scrollTop = newOffset;
									// $("HTML, BODY").animate(
									// 	{ scrollTop: newOffset },
									// 	300
									// );
									// setTimeout(() => {
									// 	document.querySelector(
									// 		"html,body"
									// 	).scrollTop = newOffset;
									// }, 1000);
								} else {
								}
							}
						}
					}
				});
			}
		});
	}
}
